import { ErrorMessage } from '@hookform/error-message';
import classNames from 'clsx';
import React, { useMemo } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import ErrorMessageText from './ErrorMessageText';
import InputLabel from './InputLabel';

export type BaseProps = {
  name: string
  label?: string | React.ReactNode;
  validation?: {
    required?: boolean;
    minLength?: number;
    maxLength?: number;
  };
  customWidth?: string;
};

interface BaseInputProps extends BaseProps {
  isFocused?: boolean;
  children: React.ReactNode;
}

export default function BaseInput({ customWidth, label, name, validation, isFocused, children }: BaseInputProps) {
  const { register } = useFormContext();
  const { fieldState: { error } } = useController({ name });
  const hasError = useMemo(() => !!error, [error]);

  if (validation) {
    if (validation.required) {
      register(name, { required: 'This field is required' });
    }

    if (validation.minLength) {
      register(name, { minLength: { value: validation.minLength, message: `Minimum length is ${validation.minLength}` } });
    }

    if (validation.maxLength) {
      register(name, { maxLength: { value: validation.maxLength, message: `Maximum length is ${validation.maxLength}` } });
    }
  }

  return (
    <div className={classNames(customWidth, "flex flex-col mb-4")}>
      {label && <InputLabel label={label} name={name} isFocused={isFocused} hasError={hasError} />}
      {children}
      <ErrorMessage
        name={name}
        render={({ message }) => <ErrorMessageText message={message} />}
      />
    </div>
  );
}
